import { render, staticRenderFns } from "./AdminReportInventoryCoverage.vue?vue&type=template&id=33a3086c&scoped=true"
import script from "./AdminReportInventoryCoverage.vue?vue&type=script&lang=js"
export * from "./AdminReportInventoryCoverage.vue?vue&type=script&lang=js"
import style0 from "./AdminReportInventoryCoverage.vue?vue&type=style&index=0&id=33a3086c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3086c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a3086c')) {
      api.createRecord('33a3086c', component.options)
    } else {
      api.reload('33a3086c', component.options)
    }
    module.hot.accept("./AdminReportInventoryCoverage.vue?vue&type=template&id=33a3086c&scoped=true", function () {
      api.rerender('33a3086c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminReportInventoryCoverage.vue"
export default component.exports